module.exports = __webpack_public_path__ + "img/chevron-up--white.17b9353b.svg";